import { useCallback, useEffect } from "react";
import { useForm } from "react-hook-form";

export interface EmailTypeFormValues {
  description: string;
}

interface UseEmailTypeFormParams {
  description?: string | null;
  onSubmitDescription: (description: string | null) => Promise<unknown>;
}

export const useEmailTypeForm = ({
  description,
  onSubmitDescription,
}: UseEmailTypeFormParams) => {
  const form = useForm<EmailTypeFormValues>({
    defaultValues: {
      description: "",
    },
  });

  useEffect(() => {
    form.reset({
      description: description ?? "",
    });
  }, [description, form]);

  const handleSubmit = useCallback(
    async (values: EmailTypeFormValues) => {
      await onSubmitDescription(values.description.trim() || null);
      form.reset(form.getValues());
    },
    [form, onSubmitDescription],
  );

  return {
    form,
    handleSubmit,
  };
};
